import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { EscriptStatusRecord } from '../pharmacy-escript.descriptor';

/**
 * Status for webhook vendors (Dischem, ComputAssist): a real-time Firestore stream off the
 * top-level orders collection. The per-vendor `normalize` adapts the raw doc to
 * `EscriptStatusRecord` (e.g. Dischem's pre-append-1 / infer-cancelled-3).
 */
@Injectable({ providedIn: 'root' })
export class FirestoreStreamStatusSource {
  constructor(private firestore: AngularFirestore) {}

  stream$(
    collection: string,
    docId: string,
    normalize: (doc: any) => EscriptStatusRecord | null
  ): Observable<EscriptStatusRecord | null> {
    if (!docId) {
      return of(null);
    }
    return this.firestore
      .collection(collection)
      .doc(docId)
      .valueChanges()
      .pipe(map((doc: any) => normalize(doc)));
  }
}
